export enum ButtonTheme {
  Primary = "Primary",
}
